export enum StepSection {
  GettingStarted = 'GS',
  AboutYou = 'AY',
  Property = 'P',
  PreApproval = 'PA',
  IncomeAndAssets = 'IA',
  Submit = 'S'
}